import { isEmpty } from "lodash";
import {
  PPS_ROUTE,
  STAFF_GROUPS_ROUTE,
  PPS_GROUPS_ROUTE,
  STAFF_ROUTE,
  USERS_EDIT_ROUTE,
  USERS_SEARCH_ROUTE,
  STAFF_EDIT_ROUTE,
  USERS_GROUPS_ROUTE,
  USERS_ROUTE,
  CONTROLLERS_ROUTE,
  EVENT_LOG_ROUTE,
  NEWS_ROUTE,
  EXAM_ROUTE,
  INFO_STAFF_EDIT_ROUTE,
  INFO_USERS_EDIT_ROUTE,
  PPS_EDIT_ROUTE,
  PASS_EDIT_ROUTE,
  TAGS_ROUTE,
  USERS_ADDITION_ROUTE,
  KEYS_ROUTE,
  PASS_ROUTE,
  EVENTS_ROUTE,
  SPECIALITY_GROUPS_ROUTE,
  INFO_SPECIALITY_EDIT_ROUTE,
  INFO_PPS_EDIT_ROUTE,
  EVENT_ROUTE,
  RATING_ROUTE,
  SYSTEM_CONFIG_ROUTE
} from "../router/names";
import { getConfig } from "@/services/systemConfig.service";

export function createAbility() {
  const rules = {};

  const allow = (target, rule, access = true) => {
    if (isEmpty(rules[target])) {
      rules[target] = {
        abilities: [{ rule, access }]
      };
    } else {
      rules[target].abilities.push({ rule, access });
    }
  };

  const deny = (target, rule) => allow(target, rule, false);

  const isAllow = (target, rule) => {
    const targetRule = rules[target];

    if (isEmpty(targetRule)) {
      return false;
    } else {
      const foundRule = targetRule.abilities.find(ab => ab.rule === rule);

      if (foundRule) {
        return foundRule.access;
      } else {
        return false;
      }
    }
  };

  return { rules, allow, deny, isAllow };
}

export function defineAccessFor(user) {
  const { allow, deny, isAllow, rules } = createAbility();

  const routeModuleMap = {
    [RATING_ROUTE]: "rating",
    [EXAM_ROUTE]: "exam",
    [KEYS_ROUTE]: "keys",
    [TAGS_ROUTE]: "tags",
    [EVENTS_ROUTE]: "events",
    [PASS_ROUTE]: "pass",
    [PASS_EDIT_ROUTE]: "pass"
  };

  const config = getConfig();
  const modules = config && config.modules ? config.modules : [];

  Object.entries(routeModuleMap).forEach(([route, moduleName]) => {
    if (!modules.includes(moduleName)) {
      deny("routes", route);
    }
  });

  const groups = user.groups || [];

  groups.forEach(group => {
    const hasEntrant = user.management.find(m => m.category.type === "ENTRANT");
    const hasStaff = user.management.find(m => m.category.type === "STAFF");
    const hasPPS = user.management.find(m => m.category.type === "PPS");

    switch (group.toString().toUpperCase()) {
      case "ADMIN":
        if (hasEntrant) {
          allow("routes", USERS_ROUTE);
          allow("routes", USERS_GROUPS_ROUTE);
          allow("routes", SPECIALITY_GROUPS_ROUTE);
          allow("routes", USERS_EDIT_ROUTE);
        }

        if (hasStaff) {
          allow("routes", STAFF_ROUTE);
          allow("routes", STAFF_GROUPS_ROUTE);
          allow("routes", PPS_GROUPS_ROUTE);
          allow("routes", STAFF_EDIT_ROUTE);
        }

        if (hasPPS) {
          allow("routes", PPS_ROUTE);
          allow("routes", PPS_EDIT_ROUTE);
        }

        allow("routes", USERS_SEARCH_ROUTE);
        allow("routes", USERS_ADDITION_ROUTE);
        allow("routes", CONTROLLERS_ROUTE);
        allow("routes", EVENT_LOG_ROUTE);
        allow("routes", INFO_STAFF_EDIT_ROUTE);
        allow("routes", INFO_PPS_EDIT_ROUTE);
        allow("routes", INFO_USERS_EDIT_ROUTE);
        allow("routes", INFO_SPECIALITY_EDIT_ROUTE);
        allow("routes", KEYS_ROUTE);
        allow("routes", PASS_ROUTE);
        allow("routes", PASS_EDIT_ROUTE);
        allow("routes", EVENTS_ROUTE);
        allow("routes", EVENT_ROUTE);
        allow("routes", NEWS_ROUTE);
        allow("routes", EXAM_ROUTE);
        allow("routes", RATING_ROUTE);
        allow("routes", TAGS_ROUTE);
        allow("routes", SYSTEM_CONFIG_ROUTE);
        allow("tabs", "access_control");
        allow("tabs", "rating_request");
        allow("elem", "download_data");
        allow("elem", "rating_commission");
        break;

      case "MANAGER":
        if (hasEntrant) {
          allow("routes", USERS_ROUTE);
          allow("routes", USERS_EDIT_ROUTE);
        }

        if (hasStaff) {
          allow("routes", STAFF_ROUTE);
          allow("routes", STAFF_EDIT_ROUTE);
        }

        if (hasPPS) {
          allow("routes", PPS_ROUTE);
          allow("routes", PPS_EDIT_ROUTE);
        }

        allow("routes", "home");
        allow("routes", NEWS_ROUTE);
        allow("routes", EXAM_ROUTE);
        allow("routes", USERS_SEARCH_ROUTE);
        allow("routes", INFO_STAFF_EDIT_ROUTE);
        allow("routes", INFO_PPS_EDIT_ROUTE);
        allow("routes", INFO_USERS_EDIT_ROUTE);
        allow("elem", "download_data");

        deny("tabs", "access_control");

        break;

      case "PASS_MANAGER":
        allow("routes", "home");
        allow("routes", PASS_ROUTE);
        allow("routes", PASS_EDIT_ROUTE);
        allow("routes", EVENTS_ROUTE);
        allow("routes", EVENT_ROUTE);

        break;

      case "RATING_MANAGER":
        allow("routes", "home");
        allow("tabs", "rating_request");

        break;

      case "RATING_COMMISSION":
        allow("routes", RATING_ROUTE);
        allow("routes", "home");
        allow("tabs", "rating_request");
        allow("elem", "rating_commission");
        break;
    }
  });

  return { rules, isAllow };
}
